import { TranslationKeys } from "src/@types/i18next";

export type Locale = {
  id: number;
  code: string;
  name: string;
  nativeName: string;
  nameTranslation: TranslationKeys["common"];
};

export function getLocales(): Locale[] {
  return [
    {
      id: 1,
      code: "en",
      name: "English",
      nativeName: "English",
      nameTranslation: "common:language_english",
    },
    {
      id: 2,
      code: "fr",
      name: "French",
      nativeName: "Français",
      nameTranslation: "common:language_french",
    },
  ];
}

// This function will be irrelevant if more than two locales are added.
// The purpose is to return french if the locale is english and vice versa.
export function getAlternateLocaleByCode(code: string): Locale {
  return getLocales().find((locale) => locale.code !== code) || getLocales()[0];
}

export function getLocaleByCode(code: string): Locale {
  return getLocales().find((locale) => locale.code === code) || getLocales()[0];
}
